import { combineReducers } from "redux";
import maps from "./mapReducer";
import companies from "./companyReducer";

export default combineReducers({
  maps,
  companies
});